import axios from 'axios';
import grispiApi from '../apis/grispiApi';
import grispiEndUserApi from '../apis/grispiEndUserApi';
import endPoints from '../services/endpoints';
import { sleep } from './helpers';

/**
 * @arg see https://swr.vercel.app/docs/arguments#multiple-arguments
 */
export const endUserPublicFetcher = async (arg: string | string[]): Promise<any> => {
    const url = Array.isArray(arg) ? arg[0] : arg;
    const res = await grispiEndUserApi.get(url);
    return res.data;
};

// never use try catch in fetcher. fetcher needs to throw errors
export const fetcherWithToken = async (arg: string | string[]): Promise<any> => {
    const url = Array.isArray(arg) ? arg[0] : arg;
    const res = await grispiApi.get(url);

    return res.data;
};

const getSearchParamsKeyForAPI = (endPoint: string): string => {
    if (!endPoint) {
        // console.debug('getSearchParamsKeyForAPI: endPoint is not defined');
        return null;
    }

    const paramKey =
        endPoint.startsWith(endPoints.search.customers) ||
        endPoint.startsWith(endPoints.search.organizations) ||
        endPoint.startsWith(endPoints.search.tickets) ||
        endPoint.startsWith(endPoints.autoComplete.tagSearch) ||
        endPoint.startsWith(endPoints.autoComplete.mention)
            ? 'searchTerm'
            : null;

    return paramKey;
};
// fetcher for endpoints, see: src/services/endpoints
export const fetcherWithTokenWithParams = async <T>(arg: string | string[], urlParam?: string): Promise<T> => {
    const url = Array.isArray(arg) ? arg[1] : urlParam;
    const searchTerm = Array.isArray(arg) ? arg[0] : arg;

    const paramKey = getSearchParamsKeyForAPI(url);

    if (!paramKey) {
        // console.debug(`fetcherWithTokenWithParams, url:${url} is not avaliable to search anything with params`);
        return;
    }

    const params = paramKey ? { [paramKey]: searchTerm } : null;

    const res = await grispiApi.get(url, { params });
    return res.data;
};

// dev purpose only
export const jsonServerFetcher = async (url: string): Promise<any> => {
    const res = await axios.get(url);

    return res.data;
};

export const fakeFetcher = (data: any) => async (): Promise<any> => {
    await sleep(3000);
    return data;
};
